import { Badge, Button, ButtonProps } from '@mui/material'
import { useNavigate } from 'react-router'
import { useAppSelector } from 'store/configureStore'

export const IncomingRfqsButton = (props: ButtonProps) => {
  const navigate = useNavigate()
  const partyId = useAppSelector((state) => state.user?.organizationContext?.id)
  const count = useAppSelector(
    (state) => state.quotationExchange.actionableIncomingRfqCount,
  )

  if (!partyId) {
    return null
  }

  return (
    <Badge
      badgeContent={count}
      color="primary"
      showZero={false}
      max={99}
      sx={{
        '& .MuiBadge-badge': {
          top: 4,
          right: 4,
          transform: 'none',
        },
      }}
    >
      <Button
        {...props}
        onClick={() => {
          navigate('/app/request-for-quotations/incoming')
        }}
      >
        Incoming RFQs
      </Button>
    </Badge>
  )
}

export const OutgoingRfqsButton = (props: ButtonProps) => {
  const navigate = useNavigate()
  const partyId = useAppSelector((state) => state.user?.organizationContext?.id)

  if (!partyId) {
    return null
  }

  return (
    <Button
      {...props}
      onClick={() => navigate('/app/request-for-quotations/outgoing')}
    >
      Outgoing RFQs
    </Button>
  )
}
